import template from './riccardo-deal-list.html.twig';

const { Criteria } = Shopware.Data;

export default {
    template,

    inject: ['repositoryFactory'],

    data() {
        return {
            deals: null,
            isLoading: false,
            total: 0,
        };
    },

    metaInfo() {
        return { title: this.$createTitle() };
    },

    computed: {
        dealRepository() {
            return this.repositoryFactory.create('riccardo_deal');
        },

        columns() {
            return [
                { property: 'active', label: this.$t('riccardo-deal.list.columnActive'), width: '90px', align: 'center' },
                { property: 'name', label: this.$t('riccardo-deal.list.columnName'), routerLink: 'riccardo.deal.detail', primary: true },
                { property: 'product.translated.name', label: this.$t('riccardo-deal.list.columnProduct') },
                { property: 'priceValue', label: this.$t('riccardo-deal.list.columnDealPrice') },
                { property: 'minQualifyingValue', label: this.$t('riccardo-deal.list.columnCondition') },
                { property: 'behavior', label: this.$t('riccardo-deal.list.columnBehavior') },
                { property: 'validUntil', label: this.$t('riccardo-deal.list.columnValidUntil') },
            ];
        },
    },

    created() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;
            const criteria = new Criteria(1, 50);
            criteria.addAssociation('product');
            criteria.addSorting(Criteria.sort('priority', 'DESC'));

            return this.dealRepository.search(criteria).then((result) => {
                this.deals = result;
                this.total = result.total;
            }).finally(() => {
                this.isLoading = false;
            });
        },

        formatPrice(deal) {
            return deal.priceType === 'percent' ? `−${deal.priceValue} %` : `${Number(deal.priceValue).toFixed(2).replace('.', ',')} €`;
        },

        formatCondition(deal) {
            const value = `${Number(deal.minQualifyingValue).toFixed(2).replace('.', ',')} €`;
            const label = deal.qualifyingLabel || this.$t('riccardo-deal.list.anyGoods');
            const margin = deal.minMargin ? ` · ≥ ${deal.minMargin} % Marge` : '';
            return `ab ${value} ${label}${margin}`;
        },
    },
};
